import dayjs from 'dayjs';
import betsSVG from './img/bets.svg';
import bonusSVG from './img/bonus.svg';
import depositsSVG from './img/deposits.svg';
import generalSVG from './img/general.svg';
import playersSVG from './img/players.svg';
import structureSVG from './img/structure.svg';
import withdrawalsSVG from './img/withdrawals.svg';
import dateSVG from './img/date.svg';

const dateSelection = {
  key: 'choosePeriod',
  value: 'date',
  isSelector: true,
  from: null,
  to: null,
  active: false,
  icon: dateSVG,
};

const tableTypes = {
  single: 'single',
  general: 'general',
  list: 'list',
};

const BALANCE_ACTIONS = ['balance', 'partner_balance'];

const balanceSections = {
  balance: {
    key: 'balance',
    value: 'balance',
  },
  partner_balance: {
    key: 'partnerBalance',
    value: 'partner_balance',
  },
};

const periods = [
  {
    key: 'today',
    value: 'today',
    from: new Date(dayjs().startOf('day')),
    to: new Date(dayjs().startOf('day').add(1, 'day')),
    active: false,
  },
  {
    key: 'yesterday',
    value: 'yesterday',
    from: new Date(dayjs().subtract(1, 'day').startOf('day')),
    to: new Date(dayjs().subtract(1, 'day').startOf('day').add(1, 'day')),
    active: false,
  },
  {
    key: 'lastWeek',
    value: 'lastWeek',
    from: new Date(dayjs().startOf('day').day(1).subtract(1, 'week')),
    to: new Date(dayjs().startOf('day').day(1).subtract(1, 'week').add(7, 'day')),
    active: false,
  },
  {
    key: 'lastMonth',
    value: 'lastMonth',
    from: new Date(dayjs().subtract(1, 'month').startOf('month')),
    to: new Date(dayjs().startOf('month')),
    active: false,
  },
  {
    key: 'currentMonth',
    value: 'currentMonth',
    from: new Date(dayjs().startOf('month')),
    to: new Date(dayjs().startOf('month').add(1, 'month')),
    active: false,
  },
  dateSelection,
];

const sections = [
  {
    key: 'general',
    value: 'general',
    active: false,
    icon: generalSVG,
    children: [
      {
        key: 'completeReport',
        value: 'complete_report',
        active: false,
      },
      {
        key: 'totalDeposits',
        value: 'total_deposits',
        active: false,
      },
      {
        key: 'totalWithdrawals',
        value: 'total_withdrawals',
        active: false,
      },
      {
        key: 'netwin',
        value: 'netwin',
        active: false,
      },
      {
        key: 'activePlayers',
        value: 'active_players',
        active: false,
      },
    ],
  },
  {
    key: 'players',
    value: 'players',
    active: false,
    icon: playersSVG,
    children: [
      {
        key: 'playersActive',
        value: 'active_players',
        active: false,
      },
      {
        key: 'playersInactive',
        value: 'players_inactive',
        active: false,
      },
      {
        key: 'playersNew',
        value: 'players_new',
        active: false,
      },
      {
        key: 'playersTop',
        value: 'players_top',
        active: false,
      },
    ],
  },
  {
    key: 'structure',
    value: 'structure',
    active: false,
    icon: structureSVG,
    children: [
      {
        key: 'agentsTotal',
        value: 'agents_total',
        active: false,
      },
      {
        key: 'agentsTop',
        value: 'agents_top',
        active: false,
      },
      {
        key: 'agentsInactive',
        value: 'agents_inactive',
        active: false,
      },
    ],
  },
  {
    key: 'deposits',
    value: 'deposits',
    active: false,
    icon: depositsSVG,
    children: [
      {
        key: 'depositsTotal',
        value: 'total_deposits',
        active: false,
      },
      {
        key: 'depositsCount',
        value: 'deposits_count',
        active: false,
      },
      {
        key: 'depositsAverage',
        value: 'deposits_average',
        active: false,
      },
      {
        key: 'depositsTopPlayers',
        value: 'deposits_top_players',
        active: false,
      },
    ],
  },

  {
    key: 'withdrawals',
    value: 'withdrawals',
    icon: withdrawalsSVG,
    active: false,
    children: [
      {
        key: 'withdrawalsTotal',
        value: 'total_withdrawals',
        active: false,
      },

      {
        key: 'withdrawalsCount',
        value: 'withdrawals_count',
        active: false,
      },

      {
        key: 'withdrawalsTopPlayers',
        value: 'withdrawals_top_players',
        active: false,
      },
    ],
  },
  {
    key: 'bets',
    value: 'bets',
    active: false,
    icon: betsSVG,
    children: [
      {
        key: 'betsTotal',
        value: 'bets_total',
        active: false,
      },
      {
        key: 'winsTotal',
        value: 'wins_total',
        active: false,
      },

      {
        key: 'netwin',
        value: 'netwin',
        active: false,
      },
      {
        key: 'withdrawalsTopPlayers',
        value: 'withdrawals_top_players',
        active: false,
      },
      {
        key: 'playersBiggestLosses',
        value: 'players_biggest_losses',
        active: false,
      },
      {
        key: 'playersBiggestWins',
        value: 'players_biggest_wins',
        active: false,
      },
    ],
  },
  {
    key: 'bonus',
    value: 'bonus',
    active: false,
    icon: bonusSVG,
    children: [
      {
        key: 'cashbackAwarded',
        value: 'cashback_awarded',
        active: false,
      },
      {
        key: 'cashbackPlayersCount',
        value: 'cashback_players_count',
        active: false,
      },
      {
        key: 'cashbackHistory',
        value: 'cashback_history',
        active: false,
      },
    ],
  },
];

export { periods, sections, dateSelection, tableTypes, BALANCE_ACTIONS, balanceSections };
